import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { PageBlogFeed } from 'components/pages/PageBlogFeed/PageBlogFeed';
import {
  contentBlogsLoadingSelector,
  contentBlogsSelector,
  contentAllBlogsLoadedSelector,
} from 'modules/content/selectors';
import { getContentBlogs } from 'modules/content/actions';
import { copy } from 'modules/copy/actions';
import { savedBlogPostsSelector, topSavedBlogPostsSelector } from 'modules/savedBlogPosts';
import { isAuthSelector } from 'modules/user/selectors';
import { getDynamicTopTrending, trendingArticlesSelector } from 'modules/trendingAcross';

const mapActionCreators = (dispatch: Dispatch) => ({
  getContentBlogs(options: { useMerge: boolean }): void {
    dispatch(getContentBlogs(options));
  },

  getDynamicTopTrendingBlog(): void {
    dispatch(getDynamicTopTrending(true));
  },

  copy: (item: State.CopiedItem) => {
    dispatch(copy(item));
  },
});

const mapStateToProps = (state: State.Root) => {
  return {
    contentBlogsLoading: contentBlogsLoadingSelector(state),
    allBlogsLoaded: contentAllBlogsLoadedSelector(state),
    contentBlogs: contentBlogsSelector(state),
    savedBlogPosts: savedBlogPostsSelector(state),
    topSavedBlogPosts: topSavedBlogPostsSelector(state),
    isAuth: isAuthSelector(state),
    trendingBlogs: trendingArticlesSelector(state),
  };
};

export const PageBlogFeedContainer = connect(mapStateToProps, mapActionCreators)(PageBlogFeed);
